// Classe di utilità: ShopifyTheme
// Gestisce eventi, integrazione privacy e caricamento funzionalità Shopify (es. consenso cookie).
// Attributi richiesti: nessuno specifico
// Dipendenze: window.Shopify, _iub.cs.api
// Limiti: richiede presenza di oggetti globali Shopify e Iubenda
// Utilizzato per la gestione privacy e tracking cookie
class ShopifyTheme {
  static EVENTS = {
    COOKIE_CONSENT: 'cookie:consent',
    COOKIE_CLOSED: 'cookie:closed',
  };
  static STORAGE = {
    COOKIE_CONSENT: 'cookie_consent',
  };

  static loadCustomerPrivacy = () => {
    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      error => {
        if (error) {
          throw new Error(error);
        } /*else {
          window.Shopify.customerPrivacy.setTrackingConsent(false, () => {
            console.log('Tracking consent set to false', window.Shopify.customerPrivacy.userCanBeTracked());
          });
        }*/
      }
    );
  }

  static iubendaIntegration = (preferences) => {
    const isPrefEmpty = !preferences || Object.keys(preferences).length === 0;
    const consent = isPrefEmpty ? _iub.cs.api.getPreferences() : preferences;
    const shopifyPurposes = {
      "analytics": [4, 's'],
      "marketing": [5, 'adv'],
      "preferences": [2, 3],
      "sale_of_data": ['s', 'sh'],
    }
    const expressedConsent = {};
    Object.keys(shopifyPurposes).forEach(function(purposeItem) {
      var purposeExpressed = null
      shopifyPurposes[purposeItem].forEach(item => {
        if (consent.purposes && typeof consent.purposes[item] === 'boolean') {
          purposeExpressed = consent.purposes[item];
        }
        if (consent.uspr && typeof consent.uspr[item] === 'boolean' && purposeExpressed !== false) {
          purposeExpressed = consent.uspr[item];
        }
      })

      if (typeof purposeExpressed === 'boolean') {
        expressedConsent[purposeItem] = purposeExpressed;
      }
    });
    localStorage.setItem(ShopifyTheme.STORAGE.COOKIE_CONSENT, JSON.stringify(expressedConsent));
    window.Shopify.customerPrivacy.setTrackingConsent(expressedConsent);
    ShopifyTheme.customEvent(ShopifyTheme.EVENTS.COOKIE_CONSENT, expressedConsent);
  }

  static customEvent = (eventName, data) => {
    window.dispatchEvent(new CustomEvent(eventName, {
      detail: data
    }));
    Shopify.analytics.publish(eventName, data);
  }

  static isPreferencesAllowed = () => {
    const consent = JSON.parse(localStorage.getItem(ShopifyTheme.STORAGE.COOKIE_CONSENT));
    return consent && consent.preferences;
  }

  static isMarketingAllowed = () => {
    const consent = JSON.parse(localStorage.getItem(ShopifyTheme.STORAGE.COOKIE_CONSENT));
    return consent && consent.marketing;
  }

  static isAnalyticsAllowed = () => {
    const consent = JSON.parse(localStorage.getItem(ShopifyTheme.STORAGE.COOKIE_CONSENT));
    return consent && consent.analytics;
  }
}